// extracted by mini-css-extract-plugin
export default {"top":"style_top__C+OAz","profile":"style_profile__RseBv","image":"style_image__HmBur","name":"style_name__QETFb","Shouts":"style_Shouts__OwVML"};